export default "__VITE_ASSET__BJ6a1fve__"